import React from "react";
import { connect } from "react-redux";
import axios from "axios";

import { Accordion, AccordionDetails, AccordionSummary, Card, Alert } from "@mui/material";
import { withStyles } from "tss-react/mui";
import extendedFormsStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle";
import CardBody from "../../components/Card/CardBody";
import SaveButton from "../../components/CustomInput/SaveButton";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";

import Table from "../../components/Table/Table.jsx";
import * as actions from "../../store/actions";
import { toast } from "react-toastify";
import { Navigate } from "react-router";
import Button from "@mui/material/Button";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper.tsx";

class Import extends React.Component {
  form = React.createRef();
  fileInputRef = React.createRef();

  state = {
    saving: false,
    hasError: false,
    count: 0,
    items: [],
    hasFile: false,
    missingColumns: [],
    missingValues: [],
    uploadedFileName: "",
    invalidColumnTypes: [],
    checkSuccess: false,
  };

  handleFileUploadChange = () => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.setState({
        hasFile: true,
        uploadedFileName: file.name,
        missingColumns: [],
        missingValues: [],
        invalidColumnTypes: [],
        hasError: false,
      });
    }
  };

  handleCheckFile = (e) => {
    e.preventDefault();

    const file = this.fileInputRef.current.files[0];

    let data = new FormData();
    data.append("bestand", file);

    axios.post("/core/producten/check", data).then((response) => {
      if (response.data.error) {
        this.setState({
          hasError: true,
          errors: response.data.error,
          missingColumns: response.data.missing_columns || [],
          missingValues: response.data.missing_values || [],
          invalidColumnTypes: response.data.invalid_column_types || [],
          checkSuccess: response.data.checkSuccess || false,
        });
      } else {
        this.setState({
          hasError: false,
          missingColumns: [],
          missingValues: [],
          invalidColumnTypes: [],
          checkSuccess: response.data.data.checkSuccess || false,
        });
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ saving: true });

    let data = new FormData(this.form.current);

    axios.post("core/producten/import", data).then((response) => {
      if (response.data.data.error) {
        this.setState({
          saving: false,
          hasError: true,
          missingColumns: response.data.data.missing_columns || [],
          missingValues: response.data.data.missing_values || [],
          invalidColumnTypes: response.data.data.invalid_column_types || [],
          checkSuccess: response.data.data.checkSuccess || false,
        });
      } else {
        this.setState({
          count: response.data.data.count,
          items: response.data.data.items,
          saving: false,
          hasError: false,
          missingColumns: [],
          missingValues: [],
          invalidColumnTypes: [],
          checkSuccess: response.data.data.checkSuccess || false,
        });
      }
    });
  };

  formatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  renderRedirect = () => {
    toast.warn("Selecteer eerst een vestiging");

    return <Navigate to={"/manager/producten"} />;
  };

  render() {
    let importedRows = this.state.items.map((item) => {
      return [item.naam, item.omschrijving, this.formatter.format(item.prijs)];
    });

    const totalMissingValues = Object.values(this.state.missingValues || {}).reduce(
      (sum, productArray) => sum + Object.keys(productArray).length,
      0
    );

    const totalInvalidColumnTypes = Object.values(this.state.invalidColumnTypes || {}).reduce(
      (sum, productArray) => sum + Object.keys(productArray).length,
      0
    );

    const totalErrors = totalInvalidColumnTypes + totalMissingValues + this.state.missingColumns.length;

    return (
      <Card>
        <CardBody>
          <GridContainer>
            <form onSubmit={this.handleSubmit} ref={this.form}>
              {this.props.vestiging_id ? (
                <input name={"vestiging_id"} type={"hidden"} value={this.props.vestiging_id} />
              ) : (
                this.renderRedirect()
              )}
              <GridContainer>
                <GridItem style={{ textAlign: "right" }} md={12} xs={12}>
                  <Button
                    variant={"contained"}
                    color={"inherit"}
                    href={"/xlsx/jamezz-producten-voorbeeld.xlsx"}
                    rel={"noopener noreferrer"}
                    sx={{ marginY: 0.5, height: 0.8 }}
                  >
                    Download voorbeeld bestand
                  </Button>
                </GridItem>
                <GridItem md={12} xs={12}>
                  <input
                    name={"bestand"}
                    onChange={this.handleFileUploadChange}
                    type={"file"}
                    id={"file-upload"}
                    style={{ display: "none" }}
                    ref={this.fileInputRef}
                  />
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={() => this.fileInputRef.current.click()}
                    sx={{ marginY: 0.5, height: 0.8 }}
                  >
                    Upload Bestand
                  </Button>
                  {this.state.uploadedFileName && (
                    <span style={{ marginLeft: "10px" }}>{this.state.uploadedFileName}</span>
                  )}
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem>
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    disabled={!this.state.hasFile}
                    onClick={this.handleCheckFile}
                    sx={{ marginY: 0.5, height: 0.8 }}
                  >
                    Check bestand
                  </Button>
                </GridItem>
                <GridItem>
                  <SaveButton
                    buttonText={"importeren"}
                    disabled={!this.state.hasFile}
                    hasError={this.state.hasError}
                    onChange={this.handleImageChange}
                    saving={this.state.saving}
                    type={"submit"}
                  />
                </GridItem>
              </GridContainer>

              {this.state.missingColumns.length > 0 ||
              Object.keys(this.state.missingValues).length > 0 ||
              Object.keys(this.state.invalidColumnTypes).length > 0 ? (
                <Alert severity={"error"}>
                  <h3>
                    <TranslationWrapper tDefault={"Aantal gevonden errors: "} tKey={"excel_import_missingColumns"} />
                    {totalErrors}
                  </h3>
                  {this.state.missingColumns && this.state.missingColumns.length > 0 ? (
                    <Box>
                      <h5>
                        <TranslationWrapper
                          tDefault={"Deze kolommen missen nog in het bestand:"}
                          tKey={"excel_import_missingColumns"}
                        />
                      </h5>
                      <ul>
                        {this.state.missingColumns.map((key, index) => (
                          <li key={index}>{key}</li>
                        ))}
                      </ul>
                    </Box>
                  ) : null}
                  {this.state.missingValues && Object.keys(this.state.missingValues).length > 0 ? (
                    <Box>
                      <h5>
                        <TranslationWrapper
                          tDefault={"Deze rijen zijn leeg, maar moeten wel een waarde krijgen:"}
                          tKey={"excel_import_missingValues"}
                        />
                      </h5>
                      {Object.entries(this.state.missingValues).map(([column, products]) => (
                        <Accordion key={`accordion_missing_values_${column}`}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>{column}</AccordionSummary>
                          <AccordionDetails>
                            <ul>
                              {Object.entries(products).map(([productId, product]) => (
                                <li key={productId}>
                                  <strong>Product {productId}:</strong> {product.product}
                                </li>
                              ))}
                            </ul>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Box>
                  ) : null}

                  {this.state.invalidColumnTypes && Object.keys(this.state.invalidColumnTypes).length > 0 ? (
                    <Box>
                      <h5>
                        <TranslationWrapper
                          tDefault={"De waarden in deze kolommen kloppen nog niet:"}
                          tKey={"excel_import_invalidColumnTypes"}
                        />
                      </h5>
                      {Object.entries(this.state.invalidColumnTypes).map(([column, products]) => (
                        <Accordion key={`accordion_invalid_columns_${column}`}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>{column}</AccordionSummary>
                          <AccordionDetails>
                            <ul>
                              {Object.entries(products).map(([productId, product]) => (
                                <li key={productId}>
                                  <strong>Product {productId}:</strong> {product.product}
                                </li>
                              ))}
                            </ul>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Box>
                  ) : null}
                </Alert>
              ) : this.state.checkSuccess ? (
                <Alert severity={"success"}>
                  <h5>
                    <TranslationWrapper tDefault={"Alle checks zijn goed gegaan!"} tKey={"excel_import_checkSuccess"} />
                  </h5>
                </Alert>
              ) : null}

              {this.state.count > 0 &&
              Object.keys(this.state.missingValues).length <= 0 &&
              Object.keys(this.state.invalidColumnTypes).length <= 0 &&
              this.state.missingColumns.length <= 0 &&
              !this.state.hasError ? (
                <GridContainer>
                  <GridItem xs={12}>
                    <h1>Geimporteerde rijen</h1>
                    <Table
                      tableData={importedRows}
                      tableHead={["Naam", "Omschrijving", "Prijs"]}
                      tableHeaderColor={"primary"}
                    />
                  </GridItem>
                </GridContainer>
              ) : null}
            </form>
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Import, extendedFormsStyle));
